import React, { useEffect, useRef } from 'react';
import { useField } from '@unform/core';

const TextArea = ({ name, label, help, ...rest }) => {
  const inputRef = useRef(null)
  const { fieldName, defaultValue, registerField, error } = useField(name)

  useEffect(() => {
    registerField({
      name: fieldName,
      path: 'value',
      ref: inputRef.current,
    })
  }, [fieldName, registerField])

  return (
    <div className="form-group">
      <label for={fieldName}>{label}</label>
      <textarea
        id={fieldName}
        ref={inputRef}
        defaultValue={defaultValue}
        className={error ? 'has-error form-control' : 'form-control'}
        cols="30"
        rows="3"
        {...rest}
      />
      {!!help
        ? error ? null : <small class="form-text text-warning">{help}</small>
        : null
      }
      {error && <span className="NameError">{error}</span>}
    </div>
  )
}
export default TextArea;